export default "__VITE_ASSET__DYKNCdNr__"